import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Stage } from '@recruitee/stages-types';
import { PreventOrphansPipe } from '@recruitee/user-interface';

import { AnonymousLearnMoreOverlayComponent } from './anonymous-learn-more-overlay.component';

@Component({
  selector: 'rt-anonymous-learn-more-trigger',
  template: `<a
      #overlayOrigin="cdkOverlayOrigin"
      overlay-origin
      [innerHTML]="'app.common.learn_more' | translate | rtPreventOrphans"
      (click)="overlay()!.toggleOverlay()"
    ></a>
    <rt-anonymous-learn-more-overlay
      [origin]="overlayOrigin"
      [anonymousStage]="anonymousStage()"
    ></rt-anonymous-learn-more-overlay>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PreventOrphansPipe,
    TranslatePipe,
    CdkOverlayOrigin,
    AnonymousLearnMoreOverlayComponent,
  ],
})
export class AnonymousLearnMoreTriggerComponent {
  public anonymousStage = input.required<Stage>();

  public overlay = viewChild(AnonymousLearnMoreOverlayComponent);
}
